export const ACCESS_TOKEN_KEY = 'access_token';
export const ACCESS_TOKEN_EXPIRES_AT_KEY = 'access_token_expires_at';

const EXPIRY_BUFFER_MS = 30_000;

export const storeAccessToken = (token: string, expiresInSeconds: number): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, String(Date.now() + expiresInSeconds * 1000));
};

// The JWT's own exp claim is authoritative; expires_in can be stale or differ from it.
const getJwtExpiryMs = (token: string): number | null => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const exp = JSON.parse(atob(payload)).exp;
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
};

// A missing token or unknown expiry is treated as expired.
export const isAccessTokenExpired = (): boolean => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  const storedExpiresAt = Number(localStorage.getItem(ACCESS_TOKEN_EXPIRES_AT_KEY));

  if (!token) {
    return true;
  }

  const expiresAt = getJwtExpiryMs(token) ?? storedExpiresAt;

  if (!expiresAt) {
    return true;
  }

  return Date.now() >= expiresAt - EXPIRY_BUFFER_MS;
};

// Some gateways answer with 200 and a "jwt expired" body instead of a 401.
export const isJwtExpiredResponse = (result: { data?: unknown; error?: { status?: unknown; data?: unknown } }): boolean => {
  if (result.error?.status === 401) {
    return true;
  }
  const body = result.error ? result.error.data : result.data;
  const text = typeof body === 'string' ? body : JSON.stringify(body ?? '');
  return /jwt expired|token expired/i.test(text);
};
